import React, { useState, useEffect } from 'react';
import { useUserAuth } from "../context/UserAuthContext";
import left from '../images/Left.png';
import { useNavigate, Link } from 'react-router-dom';
import myplanpic from '../images/myplanpic.png';
import Skeleton from 'react-loading-skeleton';
import spinner from '../images/loaderr.gif';
import more from '../images/More.png';
import { normalizeProgramList } from '../utils/NormalizeProgram';
import ProgramsErrorBoundary from './components/ErrorBoundary';


const getJointThumbnail = (joint, index) => {
  const cycleIndex = (index % 3) + 1;
  return `https://firebasestorage.googleapis.com/v0/b/snaiyu-7b192.appspot.com/o/PhysioExcercisePlanImages%2F${joint}Thumbnail${cycleIndex}.png?alt=media&token=c94ba79a-26ce-4efb-9f4f-70865845ef68`;
};

const JOINTS = ['knee', 'hip', 'shoulder', 'neck', 'back', 'ankle'];

const getProgramImage = (templateId, exerciseName, index) => {
  const tpl = (templateId || '').toLowerCase();
  const name = (exerciseName || '').toLowerCase();
  const matchedJoint = JOINTS.find(j => tpl.includes(j)) || JOINTS.find(j => name.includes(j));
  if (matchedJoint) {
    return getJointThumbnail(matchedJoint.charAt(0).toUpperCase() + matchedJoint.slice(1), index);
  }
  return myplanpic;
};

const MyProgramsInner = () => {
  const { fetchPhysioData } = useUserAuth();
  const [programs, setPrograms] = useState([]);
  const [programsCodes, setProgramsCodes] = useState([]);
  const [loading, setLoading] = useState(true);
  const [imageLoadingStates, setImageLoadingStates] = useState({});
  const [psrpFlag, setPsrpFlag] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
    const fetchPrograms = () => {
      try {
        const raw = localStorage.getItem('Program');
        console.log('MyPrograms: raw programs data from localStorage', raw);
        if (raw) {
          const parsed = JSON.parse(raw);
          
          const normalized = normalizeProgramList(parsed);
          console.log('MyPrograms: normalized programs data', normalized);
          setPrograms(normalized);
        }

        const codesRaw = localStorage.getItem('codes');
        if (codesRaw) {
          setProgramsCodes(JSON.parse(codesRaw));
        }
      } catch (err) {
        console.error('MyPrograms: failed to load from localStorage', err);
      } finally {
        setLoading(false);
      }
    };

    fetchPrograms();
  }, []);

  useEffect(() => {
    const fetchPhysio = async () => {
      try {
        const physioData = await fetchPhysioData();
        setPsrpFlag(physioData?.PSRP || false);
      } catch (err) {
        console.error('MyPrograms: failed to fetch physio data', err);
      }
    };
    fetchPhysio();
  }, []);

  const findProgramCode = (programId) => {
    const match = programsCodes?.find(code => code.id === programId);
    return match ? match.code : 'NA';
  };

  const handleImageLoad = (index) => {
    setImageLoadingStates(prev => ({ ...prev, [index]: false }));
  };

  return (
    <div className='profile-page' style={{ marginTop: '40px' }}>
      <div style={{ marginTop: "7%", marginLeft: '5%', display: 'flex', justifyContent: 'space-between', marginRight: '5%' }}>
        <div>
          <img
            className='AP-back-image'
            src={left}
            alt='back'
            onClick={() => navigate('/profile')}
          />
          &nbsp;&nbsp;
          <span className='calender-text' style={{ fontSize: '24px', fontWeight: '700' }}>My Programs</span>
        </div>
      </div>

      <div className='myplan-banner' style={{ marginBottom: '3%' }}>
        {loading ? (
          <div style={{ width: '90%' }}>
            <Skeleton height={70} />
            <Skeleton height={70} />
            <Skeleton height={70} />
          </div>
        ) : programs.length === 0 ? (
          <div style={{ padding: '20px', textAlign: 'center', color: '#888' }}>
            No programs found. Tap CREATE to add one.
          </div>
        ) : (
          <div className='program-list'>
            {programs.map((program, index) => {
              
              const rawName = program.Program_name || '';
              const templateId = program.Template_id || '';
              const programId = program.id || `program_${index}`;

              let exerciseName = psrpFlag ? rawName : rawName.replace('PSRP', '').trim();
              if (!exerciseName.endsWith('Program')) {
                exerciseName = `${exerciseName} Program`;
              }

              const imgSrc = getProgramImage(templateId, exerciseName, index);
              const programCode = findProgramCode(programId);

              return (
                <div className='program-item' key={programId}>
                  <Link
                    to={`/plan/${programId}/${encodeURIComponent(rawName)}/${programCode}`}
                    style={{ textDecoration: 'none' }}
                  >
                    <div className='myplan-body'>
                      {/* Spinner shown until image loads */}
                      {imageLoadingStates[index] !== false && (
                        <img src={spinner} alt='Loading...' className='myplan-spinner' />
                      )}
                      <img
                        src={imgSrc}
                        alt='My Plan'
                        className='myplan-image'
                        style={{ display: imageLoadingStates[index] === false ? 'block' : 'none' }}
                        onLoad={() => handleImageLoad(index)}
                        // ✅ FIX: if image fails to load (e.g. network), fall back gracefully
                        onError={(e) => {
                          e.target.src = myplanpic;
                          handleImageLoad(index);
                        }}
                      />
                      <div className='myplan-text2new' style={{ fontSize: '18px' }}>
                        {exerciseName}
                      </div>
                      <div style={{ paddingRight: '10px' }}>
                        <img className='AP-back-image' src={more} alt='more' />
                      </div>
                    </div>
                  </Link>
                </div>
              );
            })}
          </div>
        )}

        <br /><br /><br /><br /><br />

        <Link className='AP-button2' to='/joint'>
          <div className='inner-AP-button'>
            <div className='AP-text'>CREATE</div>
          </div>
        </Link>
      </div>
    </div>
  );
};

const MyPrograms = () => (
  <ProgramsErrorBoundary>
    <MyProgramsInner />
  </ProgramsErrorBoundary>
);

export default MyPrograms;